import React from 'react';
import { Image, ImageStyle, StyleProp } from 'react-native';

interface AddIconProps {
  width?: number;
  style?: StyleProp<ImageStyle>;
}

const AddIcon: React.FC<AddIconProps> = ({ width = 50, style }) => {
  return (
    <Image
      source={require('@/assets/images/Add.png')}
      style={[{ width: width, height: Math.round(width * 1.04) }, style]}
    />
  );
};

export default AddIcon;
